














































import { Component, Vue } from "vue-property-decorator";

import { AuthModule, SurveyModule } from "@/store";

@Component
export default class Dashboard extends Vue {
  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: null) => void;

  menu: Array<{ title: string; src: any; to: string; disabled?: boolean }> = [];

  userMenu = [
    {
      title: "Governance\ndell'ambito",
      src: require("../assets/governance.svg"),
      to: "/governance",
    },
    {
      title: "Prodotti\ne mercati",
      src: require("../assets/prodotti_mercati.svg"),
      to: "/products-markets",
    },
    {
      title: "Management\ndelle destinazioni",
      src: require("../assets/management_delle_destinazioni.svg"),
      to: "/management",
    },
    {
      title: "Promozione delle destinazioni",
      src: require("../assets/promozione.svg"),
      to: "/promotion",
    },
    {
      title: "Obiettivi, Iniziative e Progetti",
      src: require("../assets/obiettivi_iniziative.svg"),
      to: "/environment-plan",
    },
    {
      title: "Piano operativo annuale",
      src: require("../assets/piano_ambito.svg"),
      to: "/ambit-plan",
    },
    {
      title: "Piani operativi inviati",
      src: require("../assets/piani_passati.svg"),
      to: "/operational-plans-sent",
    },
  ];

  adminMenu = [
    {
      title: "Gestione Vocabolario",
      src: require("../assets/management_delle_destinazioni.svg"),
      to: "terms-management",
    },
    {
      title: "Gestione Prodotti Turistici",
      src: require("../assets/prodotti_mercati.svg"),
      to: "macro-products-management",
    },
    {
      title: "Report CSV/XLS",
      src: require("../assets/piano_ambito.svg"),
      to: "download-csv-xls",
    },
    {
      title: "Gestione Area Documentale",
      src: require("../assets/piani_passati.svg"),
      to: "gestione-area-documentale",
    },
    {
      title: "Gestione\nAmbiti territoriali",
      src: require("../assets/governance.svg"),
      to: "/management-territorial-areas",
    },
    {
      title: "Librerie Termini",
      src: require("../assets/library.svg"),
      to: "/libraries-management",
    },
  ];

  mounted() {
    if (this.isAdministrator) {
      this.menu = [...this.adminMenu];
    } else {
      this.menu = [...this.userMenu];
    }

    this.setSurveyType(null);
  }

  onLinkClick(to: string) {
    this.$router.replace(to).catch(error => console.log(error));
  }
}
